import dynamic from 'next/dynamic';

const EmailTemplatesGrid = dynamic(() =>
  import('./EmailTemplatesGrid/EmailTemplatesGrid')
);
const EmailTemplatesAddNew = dynamic(() =>
  import('./EmailTemplatesAddNew/EmailTemplatesAddNew')
);
const EmailTemplatesForm = dynamic(() =>
  import('./EmailTemplatesForm/EmailTemplatesForm')
);
const EmailTemplatesDetails = dynamic(() =>
  import('./EmailTemplatesDetails/EmailTemplatesDetails')
);
const EmailTemplatesEditPage = dynamic(() =>
  import('./EmailTemplatesEditPage/EmailTemplatesEditPage')
);

export {
  EmailTemplatesGrid,
  EmailTemplatesAddNew,
  EmailTemplatesForm,
  EmailTemplatesDetails,
  EmailTemplatesEditPage,
};
